<section>
  <ng-container *ngIf="timeBlock; else legacyTemplate">
    <span class="screen-reader-only">Time this rate is for</span>
    <p class="ion-no-margin">{{ timeBlock }}</p>
  </ng-container>

  <ng-template #legacyTemplate>
    <!-- Days of the week -->
    <div
      class="rate-schedule-container"
      *ngIf="dayOfWeek"
    >
      <span class="screen-reader-only">Days this rate is for</span>
      <ion-icon
        class="ion-margin-end"
        name="calendar"
      ></ion-icon>
      <p class="ion-no-margin">{{ dayOfWeek }}</p>
    </div>

    <!-- Times of the day -->
    <div
      class="rate-schedule-container ion-no-margin"
      *ngIf="timeOfDay"
    >
      <span class="screen-reader-only">Times this rate is for</span>
      <ion-icon
        class="ion-margin-end"
        name="time"
      ></ion-icon>
      <p class="ion-no-margin">{{ timeOfDay }}</p>
    </div>
  </ng-template>
</section>
